(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certification-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('certification-marquee')) {
    class CertificationMarquee extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-clm-viewport]');
        this.track = this.querySelector('[data-clm-track]');
        this.original = this.querySelector('[data-clm-original]');
        const initialClone = this.querySelector('[data-clm-clone]');
        if (!this.viewport || !this.track || !this.original || !initialClone) return;

        this.cloneTemplate = initialClone.cloneNode(true);
        this.rebuild = this.rebuild.bind(this);
        this.scheduleRebuild = () => requestAnimationFrame(this.rebuild);
        this.resizeObserver = new ResizeObserver(this.scheduleRebuild);
        this.resizeObserver.observe(this.viewport);
        this.querySelectorAll('img').forEach((image) => {
          if (!image.complete) image.addEventListener('load', this.scheduleRebuild, { once: true });
        });
        this.scheduleRebuild();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      rebuild() {
        if (!this.isConnected) return;
        this.track.querySelectorAll('[data-clm-clone]').forEach((group) => group.remove());
        this.classList.remove('clm--scrolling');

        const contentWidth = this.original.getBoundingClientRect().width;
        const viewportWidth = this.viewport.getBoundingClientRect().width;
        if (contentWidth <= 0 || viewportWidth <= 0) return;

        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const shouldScroll = isMobile || contentWidth > viewportWidth;
        if (!shouldScroll) {
          this.track.style.removeProperty('--distance');
          this.track.style.removeProperty('--duration');
          return;
        }

        this.classList.add('clm--scrolling');
        const groupWidth = this.original.getBoundingClientRect().width;

        const speed = Math.max(0, Math.min(200, Number(this.dataset.speed || 140)));
        const duration = 205 - speed;
        this.track.style.setProperty('--distance', `${groupWidth}px`);
        this.track.style.setProperty('--duration', `${duration}s`);

        const targetWidth = viewportWidth + groupWidth * 2;
        let renderedWidth = groupWidth;
        let copyCount = 0;
        while (renderedWidth < targetWidth && copyCount < 100) {
          this.track.appendChild(this.cloneTemplate.cloneNode(true));
          renderedWidth += groupWidth;
          copyCount += 1;
        }
      }
    }

    customElements.define('certification-marquee', CertificationMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('media-logo-marquee')) {
    class MediaLogoMarquee extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-media-logo-viewport]');
        this.track = this.querySelector('[data-media-logo-track]');
        this.original = this.querySelector('[data-media-logo-original]');
        const initialClone = this.querySelector('[data-media-logo-clone]');

        if (!this.viewport || !this.track || !this.original || !initialClone) return;

        this.cloneTemplate = initialClone.cloneNode(true);
        this.rebuild = this.rebuild.bind(this);
        this.scheduleRebuild = () => requestAnimationFrame(this.rebuild);
        this.resizeObserver = new ResizeObserver(this.scheduleRebuild);
        this.resizeObserver.observe(this.viewport);

        this.querySelectorAll('img').forEach((image) => {
          if (!image.complete) image.addEventListener('load', this.scheduleRebuild, { once: true });
        });

        this.scheduleRebuild();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      rebuild() {
        if (!this.isConnected || !this.track || !this.original) return;

        this.track.querySelectorAll('[data-media-logo-clone]').forEach((group) => group.remove());

        const groupWidth = this.original.getBoundingClientRect().width;
        const viewportWidth = this.viewport.getBoundingClientRect().width;

        if (groupWidth <= 0 || viewportWidth <= 0) return;

        this.track.style.setProperty('--mlm-distance', `${groupWidth}px`);

        if (this.classList.contains('media-logo-marquee--static')) return;

        const targetWidth = viewportWidth + groupWidth * 2;
        let renderedWidth = groupWidth;
        let copyCount = 0;

        while (renderedWidth < targetWidth && copyCount < 100) {
          this.track.appendChild(this.cloneTemplate.cloneNode(true));
          renderedWidth += groupWidth;
          copyCount += 1;
        }
      }
    }

    customElements.define('media-logo-marquee', MediaLogoMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-pep-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('miss-pep-hero')) {
    class MissPepHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-mph-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-mph-dot]'));
        this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = Math.max(1000, Number(this.dataset.interval || 5000));
        this.pauseOnHover = this.dataset.pauseHover === 'true';
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.previousButton = this.querySelector('[data-mph-prev]');
        this.nextButton = this.querySelector('[data-mph-next]');
        this.onPrevious = () => this.goTo(this.current - 1, true);
        this.onNext = () => this.goTo(this.current + 1, true);
        this.onVisibility = () => document.hidden ? this.stop() : this.start();
        this.onBlockSelect = (event) => {
          const slide = event.target.closest('[data-mph-slide]');
          if (!slide || !this.contains(slide)) return;
          this.stop();
          this.goTo(Number(slide.dataset.slideIndex));
        };

        if (this.previousButton) this.previousButton.addEventListener('click', this.onPrevious);
        if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.mphDot), true)));
        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
        }
        document.addEventListener('visibilitychange', this.onVisibility);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.update();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.previousButton) this.previousButton.removeEventListener('click', this.onPrevious);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      goTo(index, restart = false) {
        if (this.slides.length < 1) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.update();
        if (restart) {
          this.stop();
          this.start();
        }
      }

      update() {
        this.slides.forEach((slide, index) => {
          const active = index === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.inert = !active;
        });
        this.dots.forEach((dot, index) => {
          const active = index === this.current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      start() {
        if (!this.autoplay || this.reduceMotion || document.hidden || this.slides.length < 2 || this.timer) return;
        this.timer = window.setInterval(() => this.goTo(this.current + 1), this.interval);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('miss-pep-hero', MissPepHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-pep-product-builder"] && !Shopify.designMode) return;
  try {
    
  class MissPepProductBuilder {
    constructor(section) {
      this.section = section;
      this.variantInput = section.querySelector('[data-variant-id]');
      this.price = section.querySelector('[data-product-price]');
      this.addButton = section.querySelector('[data-add-button]');
      this.dialog = section.querySelector('[data-zoom-dialog]');
      this.mainImage = section.querySelector('.mppb__main-image');
      this.zoomImage = section.querySelector('[data-zoom-image]');
      this.variants = this.readVariants();
      this.bindGallery();
      this.bindQuantity();
      this.bindPack();
      this.bindOptions();
      this.bindDialog();
    }

    readVariants() {
      const script = this.section.querySelector('[data-variants-json]');
      if (!script) return [];
      try { return JSON.parse(script.textContent); } catch (error) { return []; }
    }

    bindGallery() {
      const thumbs = this.section.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          thumbs.forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
          if (this.mainImage) {
            this.mainImage.removeAttribute('srcset');
            this.mainImage.removeAttribute('sizes');
            this.mainImage.src = thumb.dataset.full;
            this.mainImage.alt = thumb.dataset.alt || '';
          }
          if (this.zoomImage) {
            this.zoomImage.src = thumb.dataset.zoom || thumb.dataset.full;
            this.zoomImage.alt = thumb.dataset.alt || '';
          }
        });
      });
    }

    bindQuantity() {
      const input = this.section.querySelector('[data-quantity-input]');
      const minus = this.section.querySelector('[data-quantity-minus]');
      const plus = this.section.querySelector('[data-quantity-plus]');
      if (!input || !minus || !plus) return;
      minus.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) - 1); });
      plus.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) + 1); });
    }

    bindOptions() {
      this.section.querySelectorAll('[data-option-input]').forEach((input) => input.addEventListener('change', () => this.updateVariant()));
    }

    bindPack() {
      const packInputs = this.section.querySelectorAll('[data-pack-input]');
      const quantityInput = this.section.querySelector('[data-quantity-input]');
      packInputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (input.dataset.packMode === 'quantity') {
            if (quantityInput) quantityInput.value = Math.max(1, Number(input.dataset.packQuantity || 1));
            return;
          }

          const position = Math.max(0, Number(input.dataset.optionPosition || 1) - 1);
          const selectedByPosition = new Map();
          this.section.querySelectorAll('[data-option-input]:checked').forEach((optionInput) => {
            selectedByPosition.set(Math.max(0, Number(optionInput.dataset.optionPosition || 1) - 1), optionInput.value);
          });
          selectedByPosition.set(position, input.value);
          this.section.querySelectorAll('[data-option-input]').forEach((optionInput) => {
            const optionPosition = Math.max(0, Number(optionInput.dataset.optionPosition || 1) - 1);
            if (optionPosition === position) optionInput.checked = optionInput.value === input.value;
          });
          const variant = this.variants.find((item) => {
            return item.options[position] === input.value && Array.from(selectedByPosition).every(([index, value]) => item.options[index] === value);
          });
          if (variant) this.applyVariant(variant);
        });
      });
    }

    updateVariant() {
      const selected = Array.from(this.section.querySelectorAll('[data-option-input]:checked')).map((input) => input.value);
      const variant = this.variants.find((item) => item.options.length === selected.length && item.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      this.applyVariant(variant);
    }

    applyVariant(variant) {
      if (this.variantInput) {
        this.variantInput.value = variant.id;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (this.price) this.price.textContent = variant.priceHtml;
      if (this.addButton) {
        this.addButton.disabled = !variant.available;
        this.addButton.textContent = variant.available ? this.section.dataset.addText : this.section.dataset.soldOutText;
      }
    }

    bindDialog() {
      if (!this.dialog) return;
      const open = this.section.querySelector('[data-open-zoom]');
      const close = this.section.querySelector('[data-close-zoom]');
      if (open) open.addEventListener('click', () => this.dialog.showModal());
      if (close) close.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
    }
  }

  function initMissPepProductBuilders(root = document) {
    root.querySelectorAll('[data-mppb]:not([data-mppb-ready])').forEach((section) => {
      section.dataset.mppbReady = 'true';
      new MissPepProductBuilder(section);
    });
  }

  initMissPepProductBuilders();
  document.addEventListener('shopify:section:load', (event) => initMissPepProductBuilders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-behind-taste-tabs"] && !Shopify.designMode) return;
  try {
    
  const initializeScienceTabs = (root) => {
    if (!root || root.dataset.scienceTabsReady === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[data-science-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-science-panel]'));

    if (!tabs.length) return;

    root.dataset.scienceTabsReady = 'true';

    const activateTab = (tab, moveFocus = false) => {
      tabs.forEach((currentTab) => {
        const isActive = currentTab === tab;
        currentTab.classList.toggle('is-active', isActive);
        currentTab.setAttribute('aria-selected', String(isActive));
        currentTab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isActive = panel.id === tab.getAttribute('aria-controls');
        panel.hidden = !isActive;

        panel.querySelectorAll('video').forEach((video) => {
          if (!isActive) {
            video.pause();
          } else if (root.dataset.videoAutoplay === 'true') {
            video.play().catch(() => {});
          }
        });
      });

      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = index;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex !== index) {
          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        }
      });
    });

    root.addEventListener('shopify:block:select', (event) => {
      const selectedTab = tabs.find((tab) => tab.dataset.blockId === event.detail.blockId);
      if (selectedTab) activateTab(selectedTab);
    });

    const initialTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
    activateTab(initialTab);
  };

  document.querySelectorAll('[data-science-tabs]').forEach(initializeScienceTabs);

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-science-tabs]');
    initializeScienceTabs(root);
  });

  } catch(e) { console.error(e); }
})();
})();
